export default __webpack_public_path__ + "static/media/PaikangEntrance.53435206.jpg";